/**
 * @desc: 全局组件注册
 * @create：2020/4/21
 * @author: yeungxsheng
 * @version: v1.0
 */

import Vue from 'vue'

import SVGIcon from '@/components/public/SvgIcon'; // SVG 图标组件
import DatePicker from '@/components/public/DatePicker'; // 日期选择器
import TimePicker from '@/components/public/TimePicker'; // 时间选择器
import UploadFile from '@/components/public/UploadFile'; // 上传图片
import UploadPdf from '@/components/public/uploadPdf'; // 上传PDF
import CommonPage from '@/components/public/CommonPage'; // 分页组件
import CommonQuery from '@/components/public/CommonQuery'; // 搜索栏外层容器 提供搜索查询及收起功能
import TableColumn from '@/components/public/TableColumn'; // 自适应的表格
import CommonHeader from '@/components/public/CommonHeader';// 详情页头组件
import CommonSelect from '@/components/public/CommonSelect'; // 下拉框
import CommonDialog from '@/components/public/CommonDialog'; // 提示弹窗 进行二次操作(鉴权/上送渠道/转移归属等)
import CommonTextarea from '@/components/public/CommonTextarea'; // 文本输入框

// 挂载在Vue原型上以方法调用的组件
import FunctionalAlert from '@/components/public/CommonAlert'

Vue.component(SVGIcon.name, SVGIcon)
Vue.component(DatePicker.name, DatePicker)
Vue.component(TimePicker.name, TimePicker)
Vue.component(UploadFile.name, UploadFile)
Vue.component(UploadPdf.name, UploadPdf)
Vue.component(CommonPage.name, CommonPage)
Vue.component(CommonQuery.name, CommonQuery)
Vue.component(TableColumn.name, TableColumn)
Vue.component(CommonHeader.name, CommonHeader)
Vue.component(CommonSelect.name, CommonSelect)
Vue.component(CommonDialog.name, CommonDialog)
Vue.component(CommonTextarea.name, CommonTextarea)

Vue.prototype.$alert = FunctionalAlert

const req = require.context('../assets/svg', false, /\.svg$/)
// 定义一个加载目录的函数
const requireAll = content => content.keys().map(content)
// 加载目录下的所有 svg 文件
requireAll(req)
